import React from "react";
import PropTypes from "prop-types";

import { questionProps } from "lib/propTypes";

import FollowUp from "./FollowUp";

export default class QuestionSelectMany extends React.PureComponent {
    static propTypes = {
        ...questionProps,
        handleAnswer: PropTypes.func.isRequired,
        readOnly: PropTypes.bool.isRequired,
        isLastQuestion: PropTypes.bool,
        toggleAnonymous: PropTypes.func.isRequired,
        isAnonymous: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        isLastQuestion: false,
    };

    state = {
        selected: [],
        followUp: null,
        followUpOptional: false,
        showFollowUp: this.props.readOnly ? 1 : 0,
    };

    onClick = (event) => {
        event.preventDefault();

        this.onSelect(event);
    };

    onSelect = (event) => {
        const target = event.currentTarget;
        const aid = target.dataset.id;
        const added = target.checked;

        this.setState(
            ({ selected: original }) => {
                let selected = original.slice();
                if (added) {
                    selected.push(aid);
                } else {
                    selected = selected.filter((i) => i !== aid);
                }

                const state = { selected };

                const answer = this.props.answer.find((a) => a.id === aid);
                if (answer.has_follow_up) {
                    let { showFollowUp } = this.state;
                    showFollowUp += added ? 1 : -1;

                    state.showFollowUp = showFollowUp;

                    if (showFollowUp === 0) {
                        state.followUp = null;
                        state.followUpOptional = false;
                    } else {
                        const followUps = this.props.answer.filter(
                            (a) => selected.indexOf(a.id) > -1 && a.has_follow_up,
                        );
                        const optional = followUps.filter((a) => a.follow_up_optional);
                        state.followUpOptional = followUps.length === optional.length;
                    }
                }

                return state;
            },
            () => this.handleAnswer(),
        );
    };

    onFollowUp = (followUp) => {
        this.setState({ followUp }, () => this.handleAnswer());
    };

    handleAnswer() {
        const { selected, followUp, followUpOptional, showFollowUp } = this.state;

        const data = {
            questionID: this.props.id,
            response: selected,
            responseText: null,
            canSubmit: selected.length > 0 && (!showFollowUp || followUp || followUpOptional),
        };
        if (followUp) {
            data.followUp = followUp;
        }

        this.props.handleAnswer(data);
    }

    renderCheckboxes() {
        const { answer, id, readOnly } = this.props;

        const options = answer.map((a) => (
            <li key={a.id}>
                <input
                    id={`reason-${a.id}`}
                    name={`select-one-${id}`}
                    type="checkbox"
                    data-id={a.id}
                    onChange={this.onSelect}
                    disabled={readOnly}
                />
                <label htmlFor={`reason-${a.id}`} className="questions__list-label">
                    {a.value}
                </label>
            </li>
        ));

        return <ul className="checkbox-list checkbox-list-left questions__list">{options}</ul>;
    }

    renderFollowup() {
        if (!this.props.follow_up) {
            return null;
        }

        return (
            <FollowUp
                {...this.props}
                autoSelect={false}
                handleChange={this.onFollowUp}
                optional={this.state.followUpOptional}
                visible={this.state.showFollowUp > 0}
                isLastQuestion={this.state.isLastQuestion}
                selfIdentified={!this.props.isAnonymous}
            />
        );
    }

    render() {
        return (
            <div>
                <label className="questions__title">{this.props.question}</label>
                {this.renderCheckboxes()}
                {this.renderFollowup()}
            </div>
        );
    }
}
